import { Form, Input, Modal } from "antd"
import React from "react"

export const AnalyzeDescriptionModal = ( {
	open,
	onCancel,
	onDescriptionSubmit,
} ) => {
	const [ form ] = Form.useForm()

	return (
		<Modal
			getContainer={ false }
			centered
			open={ open }
			title={ "Analyze Description" }
			width={ 850 }
			okText={ "Analyze" }
			cancelText={ "Cancel" }
			onCancel={ () => {
				form.resetFields()
				onCancel()
			} }
			onOk={ () => {
				void form.validateFields().then( ( values ) => {
					onDescriptionSubmit( values.description )
					form.resetFields()
				} )
					.catch( () => {
					} )
			} }
		>
			<Form
				preserve
				form={ form }
				layout={ "horizontal" }
				wrapperCol={ { span: 24 } }
				labelWrap
				colon={ false }
				className={ "content-scroll" }
			>
				<Form.Item
					name={ "description" }
					rules={ [
						{ required: true, message: "Please enter the description" },
						{ type: "string", min: 4 },
					] }
				>
					<Input.TextArea
						placeholder={ "Enter Skill description here" }
						rows={ 6 }
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}
